import { MESSAGING_DRAWER_WIDTH } from './config';

export const sharedMessagingSidecarStyles = {
  height: 'var(--app-height)',
  maxWidth: MESSAGING_DRAWER_WIDTH,
  width: '100%',
  margin: 0,
  right: 0
};
